/** Shared constants for the MapleLegends bitmap glyph decoder. */
export const GLYPH_HEIGHT = 12;
export const COLUMN_BITS = 12;
export const CHARSET_SPACE = " ";
export const CHARSET_NUMERIC = "0123456789";
export const CHARSET_LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
export const CHARSET_UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const CHARSET_ALPHABETIC = CHARSET_LOWERCASE + CHARSET_UPPERCASE;
export const CHARSET_ALPHANUMERIC = CHARSET_ALPHABETIC + CHARSET_NUMERIC;
export const CHARSET_SPACED_ALPHANUMERIC = CHARSET_ALPHANUMERIC + CHARSET_SPACE;
export const CHARSET_TIMESTAMP = CHARSET_NUMERIC + "[:]";
const CHARSET_SYMBOLS = Array.from({ length: 95 }, (_, index) => String.fromCharCode(32 + index))
    .filter((char) => !/[A-Za-z0-9]/u.test(char))
    .join("");
/** Printable ASCII in decoder tie-break order: common character categories first. */
export const CHARSET_PRINTABLE_ASCII = CHARSET_ALPHANUMERIC + CHARSET_SYMBOLS;
//# sourceMappingURL=constants.js.map